import React from 'react';
import './Popover.css';
import { Close } from '@videoblocks/react-icons';
import LinkButton from '../LinkButton/LinkButton';
function Popover(props) {
  const {
    moreInfo = '',
    ctaLabel = '',
    ctaHref,
    ctaOnClick,
    showTriangle = false,
    onCloseClick,
    triangleOffset = '30%',
    trianglePosition
  } = props;
  const arrowStyling = {};
  if (trianglePosition === 'top') {
    arrowStyling['left'] = triangleOffset;
  } else if (trianglePosition === 'right' || trianglePosition === 'left') {
    arrowStyling['top'] = triangleOffset;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "Popover"
  }, showTriangle && /*#__PURE__*/React.createElement("div", {
    className: 'Popover-triangle' + ' ' + trianglePosition,
    style: arrowStyling
  }), /*#__PURE__*/React.createElement(Close, {
    className: "Popover-closeButton",
    onClick: onCloseClick,
    onKeyDown: onCloseClick,
    tabIndex: 0,
    role: "button"
  }), /*#__PURE__*/React.createElement("div", {
    className: "Popover-primaryContent"
  }, props.children, ctaLabel && /*#__PURE__*/React.createElement(LinkButton, {
    className: "text-blue-700 no-underline font-semibold",
    label: ctaLabel,
    href: ctaHref,
    onClick: ctaOnClick
  })), moreInfo && /*#__PURE__*/React.createElement("div", {
    className: "Popover-extraInfo"
  }, moreInfo));
}
export default Popover;